import { create } from 'zustand';
import type { PotStatus } from '../types/pot.types';

export type PotGroupingMode = 'none' | 'status';

interface PotApprovalsUIState {
  searchText: string;
  groupingMode: PotGroupingMode;
  collapsedStatuses: Set<PotStatus>;
}

interface PotApprovalsUIActions {
  setSearchText: (text: string) => void;
  clearSearch: () => void;
  setGroupingMode: (mode: PotGroupingMode) => void;
  toggleStatusGroup: (status: PotStatus) => void;
  reset: () => void;
}

export const usePotApprovalsUIStore = create<
  PotApprovalsUIState & PotApprovalsUIActions
>(set => ({
  searchText: '',
  groupingMode: 'none',
  collapsedStatuses: new Set(),
  setSearchText: (text: string) => set({ searchText: text }),
  clearSearch: () => set({ searchText: '' }),
  setGroupingMode: groupingMode =>
    set({ groupingMode, collapsedStatuses: new Set() }),
  toggleStatusGroup: (status: PotStatus) =>
    set(state => {
      const next = new Set(state.collapsedStatuses);
      if (next.has(status)) {
        next.delete(status);
      } else {
        next.add(status);
      }
      return { collapsedStatuses: next };
    }),
  reset: () =>
    set({
      searchText: '',
      groupingMode: 'none',
      collapsedStatuses: new Set(),
    }),
}));
